import ImagePickerView from 'components/ImagePicker/views/ImagePickerView';
import SettingsImagePickerView from 'components/ImagePicker/views/SettingsImagePickerView';
import React from 'react';
import { useImagePickerState } from './ImagePicker.state';
import VisitorEntranceImagePickerView from './views/VisitorEntranceImagePicker';

export interface IImagePickerProps {
    imageURL?: string;
    onChange: Function;
    label?: string;
    view: string;
    callout?: string;
    buttonText?: string;
    imageThumbnail?: string;
}

const ImagePicker: React.FC<IImagePickerProps> = (props) => {
    const state = useImagePickerState(props.onChange, props.imageURL);

    if (props.view == 'settings') {
        return (
            <SettingsImagePickerView
                {...{
                    ...state,
                    ...{
                        imageOptions: state.fetchedImages,
                        onImageSelect: (i) => state._onImageSelect(i),
                        onFile: state.onImageUploadToLocalStorage,
                        label: props.label,
                        callout: props.callout,
                        buttonText: props.buttonText
                    }
                }}
            />
        );
    } else if (props.view == 'visitor entrance') {
        return (
            <VisitorEntranceImagePickerView
                {...{
                    ...state,
                    ...{
                        imageOptions: state.fetchedImages,
                        onImageSelect: (i) => state._onImageSelect(i),
                        onFile: state.onImageUploadToLocalStorage,
                        label: props.label,
                        buttonText: props.buttonText,
                        callout: props.callout,
                        imageThumbnail: props.imageThumbnail
                    }
                }}
            />
        );
    } else {
        return (
            <ImagePickerView
                {...{
                    ...state,
                    ...{
                        imageOptions: state.fetchedImages,
                        onImageSelect: (i) => state._onImageSelect(i),
                        onFile: state.onImageUploadToLocalStorage,
                        label: props.label
                    }
                }}
            />
        );
    }
};

export default ImagePicker;
